import {
  SimpleForm,
  SimpleFormProps,
  required,
  SelectInput,
  ReferenceInput,
  AutocompleteInput
} from 'react-admin';
import { CHOICES } from './list';

export default function HighlightsForm(props: Partial<SimpleFormProps>) {
  return (
    <SimpleForm {...props} redirect="list">
      <ReferenceInput
        fullWidth
        label="Notícia"
        sort={{ field: 'title', order: 'ASC' }}
        source="post"
        reference="posts"
        filterToQuery={searchText => ({ title: { $regex: searchText, $options: 'im' } })}
        validate={[required()]}
      >
        <AutocompleteInput optionText="title" />
      </ReferenceInput>

      <SelectInput
        choices={CHOICES}
        label="Categoria"
        source="category"
      />


    </SimpleForm>
  );
}
